var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicePageLayout',{attrs:{"title":"Maintenance","subtitle":"รายงานสถานะอุปกรณ์ปิดปรับปรุง","icon":"mdi-volume-off","icon-color":"secondary","breadcrumb":"Operations"}},[_c('v-card',{staticClass:"service-content-panel",attrs:{"flat":""}},[_c('v-card-text',[_c('DataTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }